import GoodsTracking from '@/pages/sctsnew/GoodsTracking'
import GoodsTrackingMap from '@/pages/sctsnew/GoodsTrackingMap'
import Index from '@/pages/sctsnew/Index'
import Search from '@/pages/sctsnew/Search'
import Th from '@/pages/sctsnew/th/Index'
import ThOrder from '@/pages/sctsnew/th/Order'
import ThGoods from '@/pages/sctsnew/th/Goods'
import ThTrans from '@/pages/sctsnew/th/Trans'
import ThFiles from '@/pages/sctsnew/th/Files'
import Sh from '@/pages/sctsnew/sh/Index'
import ShOrder from '@/pages/sctsnew/sh/Order'
import ShGoods from '@/pages/sctsnew/sh/Goods'
import ShTrans from '@/pages/sctsnew/sh/Trans'
import ShFiles from '@/pages/sctsnew/sh/Files'
import Thd from '@/pages/sctsnew/Thd'
import Pc from '@/pages/sctsnew/Pc'
import Asn from '@/pages/sctsnew/Asn'
import Psd from '@/pages/sctsnew/Psd'
import Abnormal from '@/pages/sctsnew/Abnormal'

let router = [{
  path: '/sctsnew/goods_tracking',
  name: 'goods_tracking',
  component: GoodsTracking,
  meta: {
    title: '货物跟踪',
    keepAlive: true
  }
}, {
  path: '/sctsnew/tracking_map',
  name: 'tracking_map',
  component: GoodsTrackingMap,
  meta: {
    title: '运输轨迹',
    keepAlive: true,
    login: false // 是否需要登录
  }
}, {
  path: '/sctsnew/',
  name: 'Index',
  component: Index,
  meta: {
    title: 'TMS运输管理系统',
    keepAlive: true
  }
}, {
  path: '/sctsnew/thd',
  name: 'thd',
  component: Thd,
  meta: {
    title: '提货单',
    role: [0]
  }
}, {
  path: '/sctsnew/Pc',
  name: 'Pc',
  component: Pc,
  meta: {
    title: '配车',
    role: [0]
  }
}, {
  path: '/sctsnew/Asn',
  name: 'Asn',
  component: Asn,
  meta: {
    title: 'Asn扫码',
    role: [0]
  }
},
{
  path: '/sctsnew/psd',
  name: 'psd',
  component: Psd,
  meta: {
    title: '送货单',
    role: [0]
  }
}, {
  path: '/sctsnew/search',
  name: 'search',
  component: Search,
  meta: {
    title: '搜索'
  }
}, {
  path: '/sctsnew/th',
  name: 'th',
  component: Th,
  meta: {
    title: '提货单'
  },
  children: [{
    path: '/sctsnew/th/order',
    name: 'order',
    component: ThOrder,
    meta: {
      title: '提货单信息'
    }
  }, {
    path: '/sctsnew/th/goods',
    name: 'goods',
    component: ThGoods,
    meta: {
      title: '货物'
    }
  }, {
    path: '/sctsnew/th/trans',
    name: 'trans',
    component: ThTrans,
    meta: {
      title: '物流'
    }
  }, {
    path: '/sctsnew/th/files',
    name: 'files',
    component: ThFiles,
    meta: {
      title: '回单'
    }
  }]
}, {
  path: '/sctsnew/sh',
  name: 'sh',
  component: Sh,
  meta: {
    title: '送货单'
  },
  children: [{
    path: '/sctsnew/sh/order',
    name: 'order',
    component: ShOrder,
    meta: {
      title: '送货单信息'
    }
  }, {
    path: '/sctsnew/sh/goods',
    name: 'goods',
    component: ShGoods,
    meta: {
      title: '货物'
    }
  }, {
    path: '/sctsnew/sh/trans',
    name: 'trans',
    component: ShTrans,
    meta: {
      title: '物流'
    }
  }, {
    path: '/sctsnew/sh/files',
    name: 'files',
    component: ShFiles,
    meta: {
      title: '回单'
    }
  }]
},
{
  path: '/sctsnew/abnormal',
  name: 'abnormal',
  component: Abnormal,
  meta: {
    title: '异常反馈',
    role: [0]
  }
}
]
export default router



// WEBPACK FOOTER //
// ./src/router/sctsnew.js